<app-section-quick-actions section="realm" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Realms</h1>
  <button type="button" class="atmos-btn atmos-btn--sm"
    (click)="toggleShowMap()">
    <mat-icon>map</mat-icon>
    <span>{{ showMap() ? 'Hide map' : 'Show map' }}</span>
  </button>
</header>

<section class="atmos-card atmos-realms__map" [class.is-hidden]="!showMap()">
  <div class="atmos-realms__map-container" #mapContainer>
    <div class="atmos-realms__map-controls">
      <button type="button"
        class="atmos-btn atmos-btn--sm"
        [class.atmos-btn--active]="showAreas()"
        [skyTooltip]="'Show areas'" placement="bottom-start"
        (click)="toggleShowAreas()">
        <mat-icon>location_on</mat-icon>
      </button>
      <button type="button"
        class="atmos-btn atmos-btn--sm"
        [class.atmos-btn--active]="showMapShrines()"
        [skyTooltip]="'Show map shrines'" placement="bottom-start"
        (click)="toggleShowMapShrines()">
        <mat-icon svgIcon="map-shrine"></mat-icon>
      </button>
      <button type="button"
        class="atmos-btn atmos-btn--sm"
        [class.atmos-btn--active]="showWingedLight()"
        [skyTooltip]="'Show winged light'" placement="bottom-start"
        (click)="toggleShowWingedLight()">
        <mat-icon svgIcon="flaps"></mat-icon>
      </button>
    </div>
    <div class="map"></div>
  </div>
</section>

<section class="atmos-realms__grid">
  @for (realm of visibleRealms; track realm.guid) {
    <app-feature-card
      [title]="realm.name"
      [titleLink]="'/realm/' + realm.guid"
      [bannerUrl]="realm.imageUrl"
      [bannerPosition]="realm.imagePosition"
      [links]="realmLinks.get(realm.guid) ?? []"
      />
  }
</section>
